import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";

export interface CatalogFacets {
	productTypes: string[];
	vendors: string[];
	tags: string[];
}

export const useCatalogFacets = () =>
	useQuery({
		queryKey: ["catalog-facets"],
		queryFn: () => api.get<CatalogFacets>("/api/catalog/facets"),
		staleTime: 5 * 60 * 1000,
	});
